export default __webpack_public_path__ + "static/media/vip8.3419562e.gif";